import { render, staticRenderFns } from "./TicketStatuses.vue?vue&type=template&id=5b0da102&scoped=true"
import script from "./TicketStatuses.vue?vue&type=script&lang=js"
export * from "./TicketStatuses.vue?vue&type=script&lang=js"
import style0 from "./TicketStatuses.vue?vue&type=style&index=0&id=5b0da102&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0da102",
  null
  
)

export default component.exports